// extracted by mini-css-extract-plugin
export default {"root":"ContainerBody_root__FTO66"};